import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BlendedCurveModalDataModel } from '@features/blended-curve-modal/blended-curve-modal-data.model';
import { BlendedCurveModalDirective } from '@features/blended-curve-modal/blended-curve-modal.component';

import { PatientCurveService } from '@models/patient-curve/patient-curve.service';
import { PatientCurveModel } from '@models/patient-curve/patient-curve.store';

import { CheckboxComponent } from '@shared/components/checkbox/checkbox.component';
import { InputComponent } from '@shared/components/input/input.component';
import { ModalComponent } from '@shared/components/modals/modal/modal.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';
import {
  CreateDriverBlendedPatientDistributionInput,
  createDriverBlendedPatientDistributionMutation,
  PatientGroup,
  UpdateDriverBlendedPatientDistributionInput,
  updateDriverBlendedPatientDistributionMutation,
} from '@shared/services/gql.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, ReactiveFormsModule, ModalComponent, CheckboxComponent, InputComponent],
  selector: 'aux-patient-blended-curve-modal',
  templateUrl:
    '../../../../../../../features/blended-curve-modal/blended-curve-modal.component.html',
})
export class PatientBlendedCurveModalComponent extends BlendedCurveModalDirective<
  PatientCurveModel,
  PatientGroup
> {
  private patientCurveService = inject(PatientCurveService);

  constituentGroups: PatientGroup[];

  constructor() {
    const ref =
      inject<CustomOverlayRef<unknown, BlendedCurveModalDataModel<PatientCurveModel>>>(
        CustomOverlayRef
      );

    super();

    this.ref = ref;

    this.constituentGroups = this.ref.data?.blendedCurve?.constituent_patient_groups || [];
  }

  createData(): CreateDriverBlendedPatientDistributionInput {
    return {
      name: this.blendedCurveForm.controls.blendedCurveName.value,
      patient_group_ids: this.selectedCurveIds,
    };
  }

  createDriverBlendedDistribution(): Promise<
    GraphqlResponse<createDriverBlendedPatientDistributionMutation>
  > {
    return this.patientCurveService.add(this.createData());
  }

  getGroupId(item: PatientCurveModel): string {
    return item.patient_group_id || '';
  }

  updateData(): UpdateDriverBlendedPatientDistributionInput {
    return {
      blended_group_id: this.ref.data?.blendedCurve?.patient_group_id || '',
      name: this.blendedCurveForm.controls.blendedCurveName.value,
      patient_group_ids: this.selectedCurveIds,
    };
  }

  updateDriverBlendedDistribution(): Promise<
    GraphqlResponse<updateDriverBlendedPatientDistributionMutation>
  > {
    return this.patientCurveService.update(this.updateData());
  }
}
